// extracted by mini-css-extract-plugin
export default {"titleNumber":"SubIssueTitle-module__titleNumber--BswFN","titleAnchor":"SubIssueTitle-module__titleAnchor--kSQVC"};